import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { AppBar, IconButton } from '@material-ui/core';
import MenuIcon from '@material-ui/icons/Menu';
import { withStyles } from '@material-ui/core/styles';
import { logoutAction } from '../../../Actions/index';
import './header.css';
import logo from '../../../images/logo.png';

const styles = theme => ({
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    display: 'inline'
  },
  navIconHide: {
    [theme.breakpoints.up('lg')]: {
      display: 'none',
    },
  },
});

class Header extends Component {
  
  constructor(props) {
    super(props);
    this.state = {
      open: false
    }
  }

  handleDrawerToggle = () => {
    this.props.toggle();
  }

  render() {
    const { classes, user } = this.props;
    const { results = {}} = user;
    return(
      <AppBar position="fixed" className={classes.appBar}>
        <IconButton color="inherit" aria-label="Open drawer" onClick={this.handleDrawerToggle} className={classes.navIconHide}>
          <MenuIcon/>
        </IconButton>
        <div className='header'>
            <div className='heading'>{results.AppUser.FirstName}
              <img src={logo} alt="logo" className="header-logo-dashboard" onClick={()=>this.props.logoutAction()}/>
            </div>
        </div>
      </AppBar>
    );
  }
}

const matchDispatchToProps = (dispatch) => {
  return bindActionCreators({ logoutAction }, dispatch);
};

export default connect(null, matchDispatchToProps)(withStyles(styles)(Header));